<template>
  <v-card
    id="listener_Produzione2"
    style="text-align: center; padding: 20px; height: 100%"
  >
    <Carrello2
      :back_as_landing_page="back_as_landing_page"
      @click_aggiungi="getWorkOrders()"
      @click_aggiungi_multiregistrazione="handleAddMultiRegistrazione"
      @click_check="handleClickCheck"
      @click_pannello_operatore="handlePannelloOperatore"
      @click_indietro="handleClickIndietro"
      @click_nascondi="nascondiWorkOrder"
      @click_registra_pezzi="clickRegistraPezzi"
      @click_visualizza_allegto_controllo="clickVisualizzaAllegatoControllo"
      @click_visualizza_disegno="clickVisualizzaDisegno"
      @click_start="clickStart"
      @click_stop="clickStop"
      :filtroEM="filtroEM"
      :handleClickCheck="handleClickCheck"
      :headers_carrello="headers_carrello"
      :items_carrello="work_orders_in_corso"
      :multicommessa_visible="multicommessa_visible"
      ref="Carrello2"
      style="width: 100%"
    />

    <!-- Dialog del consuntivo dei work order -->
    <v-dialog v-model="consuntivo_commesse_visible" width="unset">
      <ConsuntivoWorkOrder
        :items_consuntivo="work_orders_totali"
        :visible="consuntivo_commesse_visible"
        @click_chiudi="consuntivo_commesse_visible = false"
        @inviato_elemento="consuntivo_commesse_visible = false"
        v-if="consuntivo_commesse_visible == true"
      />
    </v-dialog>

    <!-- Dialog del consuntivo delle macchine multicommessa -->
    <v-dialog v-model="macchine_multi_visible">
      <ConsuntivoMacchineMulti
        :items_macchine_multi="items_macchine_multi"
        :visible="macchine_multi_visible"
        @click_chiudi="macchine_multi_visible = false"
        @selezionata_macchina="handleSelezionataMacchina"
        v-if="macchine_multi_visible === true"
      />
    </v-dialog>

    <v-dialog v-model="pannello_operatore_visible" width="1000">
      <PannelloOperatore
        :macchine="listaMacchine"
        @click_aggiungi_intervento="handleAggiungiIntervento"
        @click_chiudi="pannello_operatore_visible = false"
      />
    </v-dialog>

    <v-dialog v-model="aggiungi_intervento_visible" width="600">
      <AggiungiIntervento
        :macchine="listaMacchine"
        @click_chiudi="aggiungi_intervento_visible = false"
        @click_sospendi_intervento="handleSospendiIntervento"
        @click_concludi_intervento="handleConcludiIntervento"
      />
    </v-dialog>

    <v-dialog v-model="riepilogo_attivita_visible" width="700">
      <RiepilogoAttivita
        @click_chiudi="riepilogo_attivita_visible = false"
        @click_salva="handleSalvaIntervento"
      />
    </v-dialog>

    <!-- Dialog del consuntivo dei work order per la multicommessa -->
    <v-dialog v-model="consuntivo_wo_multi_visible">
      <ConsuntivoWorkOrderMulti
        :items_wo_multi="items_wo_multi"
        :visible="consuntivo_wo_multi_visible"
        @click_chiudi="consuntivo_wo_multi_visible = false"
        @selezionati_wo="handleSelezionatiWO"
        v-if="consuntivo_wo_multi_visible === true"
      />
    </v-dialog>

    <!-- Dialog di registrazione pezzi -->
    <!--<div
      style="
        background-color: rgba(33, 33, 33, 0.46);
        bottom: 0;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
      "
      v-if="registra_pezzi_visible"
    >
      <div
        style="height: 90%; left: 1.5%; position: absolute; top: 5%; width: 97%"
      >-->
    <v-dialog v-model="registra_pezzi_visible">
      <RegistraPezzi
        @click_controllo="clickControllo"
        @click_avanti="
          (registra_pezzi_visible = !registra_pezzi_visible),
            (registra_tempi_visible = true),
            getWorkOrdersUtente()
        "
        @click_indietro="registra_pezzi_visible = !registra_pezzi_visible"
        @click_salva_esci="
          (registra_pezzi_visible = !registra_pezzi_visible),
            getWorkOrdersUtente()
        "
        @click_salva_esci_ip="handleClickSalvaEdEsciIp"
        :flag_italproget="flag_italproget"
        :flag_em_registrazione="filtroEM === '1' ? filtroEM : ''"
        :visible="registra_pezzi_visible"
        @work_order_completato="handleWorkOrderCompletato"
        @work_order_completato_ip="handleWorkOrderCompletatoIp"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <v-dialog v-model="registra_pezzi_multi_visible">
      <RegistraPezziMulti
        @click_indietro="
          registra_pezzi_multi_visible = !registra_pezzi_multi_visible
        "
        :items_wo_multi_reg_pezzi="items_wo_multi_reg_pezzi"
        :key="key_registra_pezzi_multi"
        @registrati_pezzi="
          getWorkOrdersUtente();
          registra_pezzi_multi_visible = false;
        "
        :visible="registra_pezzi_multi_visible"
      />
    </v-dialog>

    <v-dialog persistent v-model="registra_tempi_visible">
      <RegistraTempi
        @click_avanti="
          (registra_tempi_visible = !registra_tempi_visible),
            getWorkOrdersUtente()
        "
        @click_indietro="
          (registra_tempi_visible = !registra_tempi_visible),
            (registra_pezzi_visible = !registra_pezzi_visible)
        "
        :work_order_sel="work_order_sel"
      />
    </v-dialog>
    <v-dialog persistent v-model="visualizza_disegno_visible">
      <VisualizzaDisegno
        @click_chiudi="validaDisegno"
        :visible="visualizza_disegno_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>
    <v-dialog persistent v-model="allegato_controllo_visible" width="unset">
      <GestioneAllegato
        @click_chiudi="allegato_controllo_visible = false"
        :consenti_upload="false"
        controller_allegati="Global"
        controller_caratteristiche_tabella="Manutenzione"
        :id_riferimento="
          work_order_sel != null ? work_order_sel.id_ciclo_fasi : null
        "
        ref="componenteAllegati"
        @snackbarOpen="snackbarOpen"
        tipo_allegato="CONTROLLO"
        :tipo_headers="'minimi'"
      />
    </v-dialog>
    <div
      style="
        background-color: rgba(33, 33, 33, 0.46);
        bottom: 0;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        z-index: 2;
      "
      v-if="controllo_dialog_visible"
    >
      <div
        style="height: 90%; left: 5%; position: absolute; top: 5%; width: 90%"
      >
        <Controllo
          @click_indietro="controllo_dialog_visible = false"
          :id_causale_sel="id_causale_sel"
        />
      </div>
    </div>
    <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Componente di QuickCheck -->
    <!-- Dialog del componente dinamico Check -->
    <v-dialog class="ma-0 pa-0" v-model="check_dialog_visible">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeCheck"
            :component="'check'"
            @fine_sessione_check="handleFineSessione"
            :input_args="input_args"
            :key="key_check"
            ref="windowframe_check"
            @loaded="handleCheckLoaded()"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma esecuzione QuickCheck -->
    <v-dialog v-model="conferma_check_visible" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Questionario </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            È stato rilevato un questionario non completato, vuoi terminarlo?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="noConfermaEseguiCheck()" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="confermaEseguiCheck(getrelazioni)" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Finestra di dialogo per chiudere automaticamente le commesse -->
    <v-dialog v-model="dialog_chiusure_automatiche">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Chiusura Commesse
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaChiusureCommesse"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiChiusureAutomatiche"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-data-table
            :headers="headers_chiusure_automatiche"
            :items="items_chiusure_automatiche"
          >
            <template v-slot:[`item.selezionato`]="{ item }">
              <v-checkbox
                :false-value="0"
                :true-value="1"
                v-model="item.selezionato"
              >
              </v-checkbox>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <v-snackbar
      content-class="snackbar"
      :color="snackbar_background"
      right
      style="z-index: 200001 !important"
      :timeout="3000"
      v-model="snackbar"
    >
      <v-icon :color="snackbar_icon_color" :size="64">{{
        snackbar_icon
      }}</v-icon>
      <h2 :style="{ color: snackbar_text_color + '!important' }" class="ml-16">
        {{ snackbar_text }}
      </h2>

      <v-btn
        @click="snackbar = false"
        fab
        dark
        text
        small
        style="
          margin-top: -6rem;
          float: right !important;
          margin-right: -1rem !important;
        "
      >
        <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>
<script>
import AggiungiIntervento from "@/components/PRODUCTION/ProduzioneOnline/AggiungiIntervento.vue";
import Carrello2 from "@/components/PRODUCTION/ProduzioneOnline/Carrello2.vue";
import ConsuntivoWorkOrder from "@/components/PRODUCTION/ProduzioneOnline/ConsuntivoWorkOrder.vue";
import ConsuntivoWorkOrderMulti from "@/components/PRODUCTION/ProduzioneOnline/ConsuntivoWorkOrderMulti.vue";
import ConsuntivoMacchineMulti from "@/components/PRODUCTION/ProduzioneOnline/ConsuntivoMacchineMulti.vue";
import PannelloOperatore from "@/components/PRODUCTION/ProduzioneOnline/PannelloOperatore.vue";
import RiepilogoAttivita from "@/components/PRODUCTION/ProduzioneOnline/RiepilogoAttivita.vue";
import RegistraPezzi from "@/components/PRODUCTION/ProduzioneOnline/RegistraPezzi.vue";
import RegistraPezziMulti from "@/components/PRODUCTION/ProduzioneOnline/RegistraPezziMulti.vue";
import RegistraTempi from "@/components/PRODUCTION/ProduzioneOnline/RegistraTempi.vue";
import VisualizzaDisegno from "@/components/PRODUCTION/ProduzioneOnline/VisualizzaDisegno.vue";
import GestioneAllegato from "@/components/TOOLS/GestioneAllegato.vue";
import Controllo from "@/views/PRODUCTION/Controllo/Controllo.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  components: {
    AggiungiIntervento,
    Carrello2,
    ConsuntivoMacchineMulti,
    ConsuntivoWorkOrder,
    ConsuntivoWorkOrderMulti,
    Controllo,
    GestioneAllegato,
    PannelloOperatore,
    RegistraPezzi,
    RegistraPezziMulti,
    RegistraTempi,
    RiepilogoAttivita,
    SnackbarQV,
    VisualizzaDisegno,
    WindowFrame,
  },
  props: {
    back_as_landing_page: {
      type: Boolean,
      default: true,
    },
    cod_commessa: {
      type: String,
      default: "",
    },
    commessa: {
      type: Object,
      default: () => {},
    },
    filtroEM: {
      type: String,
      default: "",
    },
    flag_italproget: {
      type: Boolean,
      default: false,
    },
    id_stato_commessa_chiusa: {
      type: Number,
      default: null,
    },
    headers_carrello: {
      type: Array,
      default: () => [
        {
          text: "Start/Stop",
          sortable: false,
          value: "start_stop",
          class: "primary--text white",
        },
        {
          text: "Registra",
          sortable: false,
          value: "registra",
          class: "primary--text white",
        },
        {
          text: "Dettagli",
          sortable: false,
          value: "visualizza_dettagli",
          class: "primary--text white",
        },
        {
          text: "Allegato Controllo",
          sortable: false,
          value: "visualizza_allegato_controllo",
          class: "primary--text white",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
          class: "primary--text white",
        },
        {
          text: "Cod. Articolo",
          sortable: false,
          value: "cod_articolo",
          class: "primary--text white",
        },
        {
          text: "Work Order",
          sortable: false,
          value: "cod_fase",
          class: "primary--text white",
        },
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
          class: "primary--text white",
        },

        {
          text: "Lavorazione",
          sortable: false,
          value: "des_fase",
          class: "primary--text white",
        },
        {
          text: "Q.tà Totale",
          sortable: false,
          value: "quantita",
          class: "primary--text white",
        },
        {
          text: "Q.tà Prodotta",
          sortable: false,
          value: "pezzi_registrati",
          class: "primary--text white",
        },
        {
          text: "Q.tà Fase Precedente",
          sortable: false,
          value: "qta_precedente",
          class: "primary--text white",
        },
        {
          text: "Ora Start",
          sortable: false,
          value: "ora_start",
          class: "primary--text white",
        },
        {
          text: "Ora Stop",
          sortable: false,
          value: "ora_stop",
          class: "primary--text white",
        },

        {
          text: "Ore Registrate",
          sortable: false,
          value: "ore_produzione",
          class: "primary--text white",
        },
        {
          text: "Q.tà Registrata",
          sortable: false,
          value: "pezzi_produzione",
          class: "primary--text white",
        },
        {
          text: "Produzione Reale",
          sortable: false,
          value: "pzhreale",
          class: "primary--text white",
        },
        {
          text: "Tempo Ciclo",
          sortable: false,
          value: "tempo_ciclo",
          class: "primary--text white",
        },
        {
          text: "Nascondi",
          sortable: false,
          value: "nascondi",
          class: "primary--text white",
          align: "center",
        },
      ],
    },
    multicommessa_visible: {
      type: Boolean,
      default: true,
    },
    open_consuntivi_if_empty: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      caricamento_dati: false,
      getrelazioni: null,
      id_causale_sel: null,
      key_registra_pezzi_multi: 0,
      work_order_sel: null,
      listaMacchine: [],
      input_args: new Object(),
      key_check: 0,
      landing_page_check: "dashboard",
      quest_app_exec_ok: false,

      // Modal
      aggiungi_intervento_visible: false,
      allegato_controllo_visible: false,
      check_dialog_visible: false,
      conferma_check_visible: false,
      consuntivo_commesse_visible: false,
      consuntivo_wo_multi_visible: false,
      controllo_dialog_visible: false,
      dialog_chiusure_automatiche: false,
      macchine_multi_visible: false,
      pannello_operatore_visible: false,
      registra_pezzi_visible: false,
      registra_pezzi_multi_visible: false,
      registra_tempi_visible: false,
      riepilogo_attivita_visible: false,
      snackbar: false,
      snackbar_background: "",
      snackbar_icon: "",
      snackbar_icon_color: "",
      snackbar_text: "",
      snackbar_text_color: "",
      stack_check: new Array(),
      visualizza_disegno_visible: false,

      // Array
      headers_chiusure_automatiche: [
        {
          text: "Commessa",
          value: "cod_commessa",
          sortable: false,
        },
        { text: "Descrizione", value: "des_commessa", sortable: false },
        { text: "Chiusura Automatica", value: "selezionato", sortable: false },
      ],
      items_chiusure_automatiche: new Array(),
      items_wo_multi: new Array(),
      items_wo_multi_reg_pezzi: new Array(),
      items_macchine_multi: new Array(),
      work_orders_in_corso: new Array(),
      work_orders_totali: new Array(),
    };
  },
  watch: {
    visible: {
      immediate: true,
      async handler() {
        if (this.visible === true) {
          // Popolo la lista delle macchine
          this.getListaMacchine();

          // Popolo l'array dei work order già presi in carico.
          await this.getWorkOrdersUtente();

          /* Se sono non ci sono WO in corso e la prop me
           * lo consente, apro il dialog dei consuntivi per
           * scegliere dei WO da aggiungere al carrello. */
          if (
            this.work_orders_in_corso.length === 0 &&
            this.open_consuntivi_if_empty === true
          ) {
            this.$refs.Carrello2.clickAggiungi();
          }
        }
      },
    },
  },
  methods: {
    aggiungiWorkOrder(messaggio) {
      // Controllo che la commessa non sia già nel carrello.
      let ricorre = false;

      this.work_orders_in_corso.forEach((elem) => {
        if (
          elem.id_commessa_dettaglio ==
          messaggio.detail.work_order_sel.id_commessa_dettaglio
        ) {
          ricorre = true;
        }
      });

      // Stampo errore se la commessa è già nel carrello.
      if (ricorre == true) {
        this.snackbar = true;
        this.snackbar_background = "grey lighten-3";
        this.snackbar_icon = "mdi-information-outline";
        this.snackbar_icon_color = "indigo";
        this.snackbar_text = "Work Order già presente nel carrello.";
        this.snackbar_text_color = "#3F51B5";
      } else {
        /* Se è tutto ok aggiungo la commessa al carrello e apro
         * la finestra di evasione della commessa.*/
        let WO_da_aggiungere = Object.assign(
          {},
          messaggio.detail.work_order_sel
        );

        this.work_orders_in_corso.push(WO_da_aggiungere);

        /* Se il work order ha un disegno e non l'ho ancora visto,
         * faccio partire automaticamente la visualizzazione del sisegno.*/
        /*if (
          WO_da_aggiungere.id_disegno != null &&
          WO_da_aggiungere.view_disegno == 0
        ) {
          this.clickVisualizzaDisegno(WO_da_aggiungere);
        }*/
      }
    },
    chiudi_allegato_controllo() {
      this.allegato_controllo_visible = false;
    },
    chiudiChiusureAutomatiche() {
      // Chiudo la finestra di dialogo.
      this.dialog_chiusure_automatiche = false;

      // Aggiorno i Work Order dell'utente.
      this.getWorkOrdersUtente();
    },
    clickConsuntivoCommesse() {
      this.consuntivo_commesse_visible = true;
    },
    clickControllo(id) {
      this.controllo_dialog_visible = true;
      // Compongo un messaggio.
      let messaggio = {
        detail: {
          id: id,
        },
        src: null,
      };

      // Inserisco il messaggio in un evento custom.
      let evento = new CustomEvent("nuovo_id", messaggio);

      // Recapito l'evento alla mia destinazione.
      setTimeout(function () {
        document
          .getElementById("listener_visualizzatore")
          .dispatchEvent(evento);
        /*console.log(
          "Mandato evento al Visualizzatore con id " + messaggio.detail.id
        );*/
      }, 1000);
    },
    clickRegistraPezzi(item) {
      this.registra_pezzi_visible = true;
      this.work_order_sel = Object.assign({}, item);
    },
    clickStart() {
      this.getWorkOrdersUtente();
    },
    clickStop(commessa) {
      // Ricarico i dati dal BE
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkordersutente",
          token: localStorage.getItem("user_token"),
          cod_commessa: this.filtroEM === "1" ? this.commessa.cod_commessa : "",
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          // Svuoto l'array che contiene le commesse in gestione
          this.work_orders_in_corso = [];

          // Popolo l'array che contiene i dati totali
          res.data.workorders.workorder.forEach((elem) => {
            /* Se ce l'ha, formatto la Produzione reale della fase
             * per convenienza di FE. */
            if (elem.pzhreale != null) {
              elem.pzhreale = elem.pzhreale.toFixed(2);
            }

            /* Se ce l'ha, formatto il tempo ciclo della fase
             * per convenienza di FE. */
            if (elem.tempo_ciclo != null) {
              elem.tempo_ciclo = elem.tempo_ciclo.toFixed(2);
            }

            this.work_orders_in_corso.push(elem);
          });

          this.caricamento_dati = false;

          // Cerco il Work Order che ho selezionato e ne apro la Dichiarazione
          this.work_orders_in_corso.forEach((elem) => {
            if (elem.id_commessa_dettaglio == commessa.id_commessa_dettaglio) {
              this.clickRegistraPezzi(elem);
            }
          });
        } else {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text = `Non è stato possibile caricare i dati: codice errore ${res.status}.`;
          this.snackbar_text_color = "white";
        }
      });
    },
    clickVisualizzaAllegatoControllo(item) {
      // Se non ci sono allegati stampo una snackbar di errore.
      if (item.check_allegato == 0) {
        this.snackbar = true;
        this.snackbar_background = "orange";
        this.snackbar_icon = "mdi-alert";
        this.snackbar_icon_color = "white";
        this.snackbar_text = "Non ci sono allegati per questo Work Order";
        this.snackbar_text_color = "white";
      } else {
        // Se invece gli allegati ci sono, faccio la chiamata per averli.
        this.allegato_controllo_visible = true;
        this.work_order_sel = Object.assign({}, item);
      }
    },
    clickVisualizzaDisegno(item) {
      if (item.view_disegno == 0) {
        /* Se il disegno non è ancora stato visualizzato mando
         * una chiamata al BE e apro il dialog. */
        let request = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setviewdisegno",
            token: localStorage.getItem("user_token"),
            id_disegno: item.id_disegno,
          },
        };

        this.$store.dispatch("api", request).then((res) => {
          if (res.status === 200) {
            this.visualizza_disegno_visible = true;
            this.work_order_sel = Object.assign({}, item);
          } else {
            this.snackbar = true;
            this.snackbar_background = "error";
            this.snackbar_icon = "mdi-close";
            this.snackbar_icon_color = "white";
            this.snackbar_text = `Non è stato possibile caricare i dati: codice errore ${res.status}.`;
            this.snackbar_text_color = "white";
          }
        });
      } else {
        /* Se il disegno è già stato visualizzato apro
         * il dialog semplicementa, senza chiamare il BE. */
        this.visualizza_disegno_visible = true;
        this.work_order_sel = Object.assign({}, item);
      }
    },
    closeCheck() {
      this.check_dialog_visible = false;
      this.$refs.SnackbarQV.print("orange", "Questionario sospeso!");
    },
    handleCheckLoaded() {
      this.$refs.windowframe_check.postEvent("setparams", {
        dizionario: JSON.parse(JSON.stringify(this.work_order_sel)),
        landing_page: this.landing_page_check,
      });
    },
    confermaEseguiCheck(arg) {
      // Imposto i dati per lanciare il questionario.
      this.input_args.id_questionario = arg.id_modulo;
      this.input_args.id_relazione = arg.id_relazione;
      this.input_args.id_relazione_log = arg.id_relazione_log;
      this.landing_page_check = "quiz_detail/" + arg.id_modulo;
      this.input_args.esterno = 1;

      this.key_check = this.key_check == 0 ? 1 : 0;

      /* Lancio il questionario e metto a false
       * l'eventuale finestra di dialogo per confermare
       * o negare la volontà dell'utente di rispondere
       * a un questionario opzionale. */
      this.check_dialog_visible = true;
      this.conferma_check_visible = false;
    },
    getWorkOrders() {
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkorders",
          token: localStorage.getItem("user_token"),
          cod_commessa: this.cod_commessa,
          filtroEM: this.filtroEM,
        },
      };

      /* Se sono su EM aggiungo l'id_articolo della commessa
       * selezionata in modo che si vedano solo i Work Orders
       * di quella commessa e di quell'articolo. */
      if (this.filtroEM === "1") {
        request.richiesta.id_articolo = this.commessa.id_articolo;
      }

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          // Svuoto l'array che contiene le commesse in gestione
          this.work_orders_totali = [];

          // Popolo l'array che contiene i dati totali

          /* Se sono in EM metto nei consutivi solo i WO che non hanno
           * ancora raggiunto la quantità che devono raggiungere. */
          if (this.filtroEM === "1") {
            res.data.forEach((elem) => {
              if (elem.pezzi_registrati < elem.quantita) {
                this.work_orders_totali.push(elem);
              }
            });
          } else {
            /* Se invece sono da un'altra parte prendo tutto quello che mi da il BE perché
             * si suppone che per qualche motivo potrei voler dichiarare pezzi in aggiunta anche
             * su fasi di lavorazione che hanno già raggiunto la quantità di materiale richiesta. */
            res.data.forEach((elem) => {
              this.work_orders_totali.push(elem);
            });
          }

          // Apro il dialog delle fasi avviabili.
          this.consuntivo_commesse_visible = true;
        } else {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text = `Non è stato possibile caricare i dati, codice errore: ${res.status}.`;
          this.snackbar_text_color = "white";
        }

        // Fermo l'overlay di caricamento.
        this.caricamento_dati = false;
      });
    },
    getListaMacchine() {
      let request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          res.data.macchine.forEach((m) => {
            if (m.multi_commessa == 1) {
              delete m.macchina_img;
              this.items_macchine_multi.push(m);
            }
          });
        }
      });
    },
    getRelazioniModuli(id_commessa) {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getrelazionimoduli",
          token: localStorage.user_token,
          id_riferimento: id_commessa,
          id_personale: localStorage.id,
          riferimento: "commessa",
          modulo: "questionario",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.result.dati.length > 0) {
              let object = {
                id_relazione: res.data.result.dati[0].id_relazione,
                id_modulo: res.data.result.dati[0].id_start,
                exec: res.data.result.dati[0]._exec,
                id_relazione_log: res.data.result.dati[0].id_relazione_log,
              };
              return object;
            } else {
              return {
                exec: "N",
              };
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    getWorkOrdersUtente() {
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkordersutente",
          token: localStorage.getItem("user_token"),
          cod_commessa: this.filtroEM === "1" ? this.commessa.cod_commessa : "",
        },
      };

      return this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          // Svuoto l'array che contiene le commesse in gestione
          this.work_orders_in_corso = [];

          // Popolo l'array che contiene le fasi in gestione
          res.data.workorders.workorder.forEach((elem) => {
            /* Se ce l'ha, formatto la Produzione reale della fase
             * per convenienza di FE. */
            if (elem.pzhreale != null) {
              elem.pzhreale = elem.pzhreale.toFixed(2);
            }

            /* Se ce l'ha, formatto il tempo ciclo della fase
             * per convenienza di FE. */
            if (elem.tempo_ciclo != null) {
              elem.tempo_ciclo = elem.tempo_ciclo.toFixed(2);
            }

            this.work_orders_in_corso.push(elem);
          });
        } else {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text = `Non è stato possibile caricare i dati, codice errore: ${res.status}.`;
          this.snackbar_text_color = "white";
        }

        this.caricamento_dati = false;
      });
    },
    handleAggiungiIntervento() {
      this.aggiungi_intervento_visible = true;
    },
    handleAddMultiRegistrazione() {
      this.macchine_multi_visible = true;
    },
    async handleClickCheck(arg, id_commessa, stack_obj) {
      // Registro il WO cliccato.
      this.work_order_sel = Object.assign({}, arg);

      /* Mi metto da parte l'oggetto che contiene le
       * informazioni sul questionario a cui devo rispondere. */
      const getrelazioni_tmp = await this.getRelazioniModuli(id_commessa);

      /* In base alla risposta del server, decido come regolare
       * il comportamento della logica di QuickCheck. */
      switch (getrelazioni_tmp.exec) {
        case "S":
          /* Se ho appena finito di eseguire un questionario
           * con esito positivo non chiedo più al BE se ci sono
           * questionari da eseguire e vado avanti con la normale
           * logica della funzione. */
          if (this.quest_app_exec_ok === true) {
            this.quest_app_exec_ok = false;
            return "N";
          }

          /* ... Altrimenti evo rispondere al questionario, quindi
           * metto i dati della funzione in uno stack di attesa. */
          stack_obj.obbligatorieta = "S";
          this.stack_check.push(stack_obj);

          this.confermaEseguiCheck(getrelazioni_tmp);
          return "S";
        case "N":
          return "N";
        case "X":
          /* Se getrelazioni è null lo valorizzo con l'oggetto
           * contenente le informazioni del questionario, se invece
           * non lo è vuol dire che sono già passato di qui e che ora
           * sto negando di voler eseguire un questionario opzionale
           * quindi ritornerò N come se non ci fosse alcun questionario
           * da fare. */
          if (this.getrelazioni === null) {
            this.getrelazioni = getrelazioni_tmp;

            /* Potrei rispondere al questionario: apro
             * la finestra di dialogo e mi metto da parte
             * il metodo che dovrebbe essere eseguito. Se
             * l'utente dice che non vuole eseguire il
             * questionario, lancio il metodo che mi sono
             * messo da parte. */
            stack_obj.obbligatorieta = "X";
            this.stack_check.push(stack_obj);
            this.conferma_check_visible = true;

            /* Ritorno S per far fermare la logica della
             * funzione chiamante nel componente figlio. */
            return "S";
          } else {
            this.getrelazioni = null;
            return "N";
          }

        default:
          return "N";
      }
    },
    handleClickSalvaEdEsciIp(arg_arr) {
      /* Formatto le (eventuali) commesse e le inserisco
       * nell'array di riferimento per il dialog. */
      const arr_tmp = new Array();
      arg_arr.forEach((e) => {
        e.selezionato = 0;
        arr_tmp.push(e);
      });

      // Chiudo la finestra di dialogo di registrazione dei pezzi.
      this.registra_pezzi_visible = false;

      /* Se ci sono commesse da chiudere automaticamente,
       * chiedo all'utente se le vuole chiudere davvero. */
      if (arr_tmp.length > 0) {
        this.items_chiusure_automatiche = arr_tmp;
        this.dialog_chiusure_automatiche = true;
      } else {
        /* Se invece non ci sono commesse da chiudere automaticamente,
         * aggiorno la lista delle commesse e basta. */
        this.getWorkOrdersUtente();
      }
    },
    handleFineSessione(arg) {
      if (arg.punteggio == null) {
        this.$refs.SnackbarQV.print("orange", "Questionario sospeso!");
      }

      if (arg.punteggio < 100) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Questionario completato con punteggio ${
            arg.punteggio == null ? "N/D" : arg.punteggio
          }!`
        );
      }

      if (arg.punteggio == 100) {
        this.$refs.SnackbarQV.print(
          "success",
          `Questionario completato con punteggio ${
            arg.punteggio == null ? "N/D" : arg.punteggio
          }!`
        );
      }

      this.check_dialog_visible = false;

      if (this.stack_check[0]) {
        if (
          this.stack_check[0].obbligatorieta == "X" ||
          (this.stack_check[0].obbligatorieta == "S" && arg.punteggio == 100)
        ) {
          // Registro di aver appena eseguito un questionario.
          this.quest_app_exec_ok = true;

          // Eseguo la funzione che sta attendendo nello stack.
          this.stack_check[0].funzione();

          // Azzero l'array di stack.
          this.stack_check = new Array();
        }
      }
    },
    handlePannelloOperatore() {
      this.pannello_operatore_visible = true;
    },
    handleSospendiIntervento() {
      this.aggiungi_intervento_visible = false;
      this.riepilogo_attivita_visible = true;
    },
    handleConcludiIntervento() {
      this.aggiungi_intervento_visible = false;
      this.riepilogo_attivita_visible = true;
    },
    handleSalvaIntervento() {
      this.riepilogo_attivita_visible = false;

      this.snackbar = true;
      this.snackbar_background = "success";
      this.snackbar_text =
        "Macchinario M01 Intervento #21003 Attività #1 Registrazione avvenuta con successo!";
      this.snackbar_text_color = "white";
    },
    handleClickIndietro() {
      this.$emit("click_indietro");
    },
    handleSelezionataMacchina(arg_id) {
      /* Filtro fra i work order in corso solo quelli associati alla macchina selezionata
       * e gli aggiungo un campo sel per lavorare con la checkbox nel dialog che aprirò */
      this.items_wo_multi = this.work_orders_in_corso.filter(
        (w) => w.id_macchina == arg_id
      );

      this.items_wo_multi.forEach((w) => (w.sel = false));

      // Chiudo il dialog di selezione della macchina per la multicommessa
      this.macchine_multi_visible = false;

      // Rendo visibile il dialog di selezione dei workorder per la multiregistrazione
      this.consuntivo_wo_multi_visible = true;
    },
    handleSelezionatiWO(arg_arr) {
      // Chiudo il dialog di selezione.
      this.consuntivo_wo_multi_visible = false;

      // Registro i WO che mi sono stati inviati
      this.items_wo_multi_reg_pezzi = new Array();
      arg_arr.forEach((w) => this.items_wo_multi_reg_pezzi.push(w));

      // Apro il dialog di registrazione multipla.
      this.key_registra_pezzi_multi =
        this.key_registra_pezzi_multi === 0 ? 1 : 0;
      this.registra_pezzi_multi_visible = true;
    },
    nascondiWorkOrder(item) {
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "hideworkorder",
          token: localStorage.getItem("user_token"),
          id_commessa_dettaglio: item.id_commessa_dettaglio,
        },
      };

      //console.log(JSON.stringify(request));
      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.getWorkOrdersUtente();
        } else {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text = `Non è stato possibile caricare i dati, codice errore: ${res.status}.`;
          this.snackbar_text_color = "white";
        }
        this.caricamento_dati = false;
      });
    },
    redirect() {
      this.$router.push("/home/production/controllo");
    },
    salvaChiusureCommesse() {
      // Controllo che ci siano commesse da salvare.
      if (
        this.items_chiusure_automatiche.filter((e) => e.selezionato == 1)
          .length == 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare almeno una commessa da chiudere."
        );
        return;
      }

      // Metto da parte le commesse da chiudere e le formatto.
      const commesse_tmp = new Array();

      this.items_chiusure_automatiche.forEach((c) => {
        if (c.selezionato == 1) {
          commesse_tmp.push(c.id_commessa);
        }
      });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessestato",
          token: localStorage.user_token,
          tabella: commesse_tmp,
          id_tabella: this.id_stato_commessa_chiusa,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            /* Emetto un evento per il componente padre che
             * fa chiudere il componente attuale e aggiorna
             * i dati alla luce della chiamata appena effettuata. */
            this.$emit("click_indietro");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    snackbarOpen() {
      // Funzione lanciata per segnalare allegati che non hanno la descrizione.
      this.snackbar = true;
      this.snackbar_background = "orange";
      this.snackbar_icon = "mdi-alert";
      this.snackbar_icon_color = "white";
      this.snackbar_text =
        "Aggiungere ad ogni Allegato dell'attività una descrizione.";
      this.snackbar_text_color = "white";
    },
    validaDisegno(arg) {
      // Chiudo il dialog di visualizzazione dei disegni.
      this.visualizza_disegno_visible = false;

      /* Metto a 1 la visione del disegno per tutti
       * gli oggetti che hanno questo id_ disegno. */
      this.work_orders_in_corso.forEach((elem) => {
        if (elem.id_disegno == arg.id_disegno) {
          elem.view_disegno = 1;
        }
      });
    },
    handleWorkOrderCompletato() {
      this.snackbar = true;
      this.snackbar_background = "success";
      this.snackbar_icon = "mdi-check";
      this.snackbar_icon_color = "white";
      this.snackbar_text = "Work Order Completato!";
      this.snackbar_text_color = "white";
    },
    handleWorkOrderCompletatoIp(arg_arr) {
      this.snackbar = true;
      this.snackbar_background = "success";
      this.snackbar_icon = "mdi-check";
      this.snackbar_icon_color = "white";
      this.snackbar_text = "Work Order Completato!";
      this.snackbar_text_color = "white";

      /* Formatto le (eventuali) commesse e le inserisco
       * nell'array di riferimento per il dialog. */
      const arr_tmp = new Array();
      arg_arr.forEach((e) => {
        e.selezionato = 0;
        arr_tmp.push(e);
      });

      // Chiudo la finestra di dialogo di registrazione dei pezzi.
      this.registra_pezzi_visible = false;

      /* Se ci sono commesse da chiudere automaticamente,
       * chiedo all'utente se le vuole chiudere davvero. */
      if (arr_tmp.length > 0) {
        this.items_chiusure_automatiche = arr_tmp;
        this.dialog_chiusure_automatiche = true;
      } else {
        /* Se invece non ci sono commesse da chiudere automaticamente,
         * aggiorno la lista delle commesse e basta. */
        this.getWorkOrdersUtente();
      }
    },
    getMacchine() {
      const getlistamacchine = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", getlistamacchine).then((res) => {
        if (res.status === 200) {
          this.listaMacchine = res.data.macchine;
        }
      });
    },
  },
  mounted() {
    this.getMacchine();

    document
      .getElementById("listener_Produzione2")
      .addEventListener("clicked_row", this.aggiungiWorkOrder);
  },
};
</script>
<style scoped>
</style>